// Fetch categories from the API
import instance from "../../utils/axios";

export const logoutAccount = async () => {
  try {
    return await instance.post(`/logout`);
  } catch (error) {
    console.error("Error fetching categories:", error.message);
    throw error; // Rethrow for further handling
  }
};
